import { useNavigate } from 'react-router-dom';

const StatusSistema = () => {
    const navigate = useNavigate();

    // Simulação de status dos sistemas
    const sistemas = [
        { nome: 'Conversão de Sites', status: 'operacional', descricao: 'Sistema de transformação de sites em apps' },
        { nome: 'Publicação Google Play', status: 'operacional', descricao: 'Upload e publicação na Play Store' },
        { nome: 'Publicação App Store', status: 'operacional', descricao: 'Upload e publicação na Apple Store' },
        { nome: 'Sistema de Notificações', status: 'operacional', descricao: 'Envio de notificações push' },
        { nome: 'Painel Administrativo', status: 'operacional', descricao: 'Área de gerenciamento do cliente' },
    ];

    const getStatusColor = (status) => {
        switch (status) {
            case 'operacional': return 'bg-green-500';
            case 'instavel': return 'bg-yellow-500';
            case 'fora': return 'bg-red-500';
            default: return 'bg-gray-500';
        }
    };

    const getStatusText = (status) => {
        switch (status) {
            case 'operacional': return 'Operacional';
            case 'instavel': return 'Instável';
            case 'fora': return 'Fora do Ar';
            default: return 'Desconhecido';
        }
    };

    return (
        <div className="min-h-screen bg-gray-50 py-12">
            <div className="container mx-auto px-4 max-w-4xl">
                <button
                    onClick={() => navigate(-1)}
                    className="inline-flex items-center text-purple-600 hover:text-purple-700 mb-8"
                >
                    <i className="fas fa-arrow-left mr-2"></i>
                    Voltar
                </button>

                <div className="bg-white rounded-lg shadow-lg p-8">
                    <h1 className="text-3xl font-bold text-gray-900 mb-2">Status do Sistema</h1>
                    <p className="text-gray-600 mb-8">Monitoramento em tempo real dos nossos serviços</p>

                    <div className="mb-8 p-4 bg-green-50 border border-green-200 rounded-lg">
                        <div className="flex items-center">
                            <div className="w-3 h-3 bg-green-500 rounded-full mr-3"></div>
                            <span className="text-green-800 font-medium">Todos os sistemas estão operacionais</span>
                        </div>
                        <p className="text-green-600 text-sm mt-2">Última verificação: {new Date().toLocaleString('pt-BR')}</p>
                    </div>

                    <div className="space-y-6">
                        {sistemas.map((sistema, index) => (
                            <div key={index} className="flex items-center justify-between p-4 border border-gray-200 rounded-lg">
                                <div>
                                    <h3 className="font-semibold text-gray-800">{sistema.nome}</h3>
                                    <p className="text-gray-600 text-sm">{sistema.descricao}</p>
                                </div>
                                <div className="flex items-center">
                                    <div className={`w-3 h-3 rounded-full mr-2 ${getStatusColor(sistema.status)}`}></div>
                                    <span className="text-gray-700">{getStatusText(sistema.status)}</span>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="mt-8 p-6 bg-gray-50 rounded-lg">
                        <h3 className="font-semibold text-gray-800 mb-3">O que é o Status do Sistema?</h3>
                        <p className="text-gray-700 text-sm">
                            Esta página mostra o status atual de todos os nossos sistemas principais.
                            O monitoramento é feito 24/7 para garantir que nossos serviços de transformação
                            de sites em aplicativos estejam sempre disponíveis.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StatusSistema;